import { BulletsIcon, Button, css, SnapshotIcon, Stack, styled, SyncIcon, TrashIcon } from 'canoe';
import React from 'react';

import {
  PlacementsTabCTA,
  PlacementsTabCTAWrapper,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';

const CaptionText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.White};
    font-weight: ${theme.fontWeights.bold};
    margin-left: ${theme.spaces.xs};
  `}
`;
const ButtonText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fonts.small.fontSize};
  `}
`;

interface ActionButtonsProps {
  onAddClick?: VoidFunction;
  onRetakeClick?: VoidFunction;
  onRemoveClick?: VoidFunction;
  onOpenListClick?: VoidFunction;
}

export const ActionButtons = ({
  onAddClick,
  onRetakeClick,
  onRemoveClick,
  onOpenListClick,
}: ActionButtonsProps) => {
  if (!onAddClick && !onRetakeClick && !onRemoveClick && !onOpenListClick) {
    // safety check
    return null;
  }

  return (
    <div>
      <CaptionText>Snapshot options:</CaptionText>

      <PlacementsTabCTAWrapper>
        {onRetakeClick && (
          <PlacementsTabCTA>
            <Button variant="white" appearance="text" size="small" inline onClick={onRetakeClick}>
              <Stack space="xxs" justify="center">
                <SyncIcon color="White" size="s" />
                <ButtonText>Retake</ButtonText>
              </Stack>
            </Button>
          </PlacementsTabCTA>
        )}

        {onAddClick && (
          <PlacementsTabCTA>
            <Button variant="white" appearance="text" size="small" inline onClick={onAddClick}>
              <Stack space="xxs" justify="center">
                <SnapshotIcon color="White" size="s" />
                <ButtonText>Add New</ButtonText>
              </Stack>
            </Button>
          </PlacementsTabCTA>
        )}

        {onOpenListClick && (
          <PlacementsTabCTA>
            <Button variant="white" appearance="text" size="small" inline onClick={onOpenListClick}>
              <Stack space="xxs" justify="center">
                <BulletsIcon color="White" size="s" />
                <ButtonText>Use Existing</ButtonText>
              </Stack>
            </Button>
          </PlacementsTabCTA>
        )}

        {onRemoveClick && (
          <PlacementsTabCTA>
            <Button variant="white" appearance="text" size="small" inline onClick={onRemoveClick}>
              <Stack space="xxs" justify="center">
                <TrashIcon color="White" size="s" />
                <ButtonText>Remove</ButtonText>
              </Stack>
            </Button>
          </PlacementsTabCTA>
        )}
      </PlacementsTabCTAWrapper>
    </div>
  );
};
